/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AgeGroup } from './AgeGroup';
import {
    AgeGroupFromJSON,
    AgeGroupFromJSONTyped,
    AgeGroupToJSON,
    AgeGroupToJSONTyped,
} from './AgeGroup';

/**
 * 
 * @export
 * @interface Horse
 */
export interface Horse {
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    registerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    colorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    breed?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    breedId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Horse
     */
    birthday?: Date | null;
    /**
     * 
     * @type {AgeGroup}
     * @memberof Horse
     */
    ageGroup?: AgeGroup;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    mother?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    motherRegId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    father?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    fatherRegId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    owner?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    ownerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    ownerRegId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    breeder?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    breederRegId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    stockSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    isBigHorse?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    lNr?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    size?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Horse
     */
    igvKennziffer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Horse
     */
    accessCode?: string | null;
}



/**
 * Check if a given object implements the Horse interface.
 */
export function instanceOfHorse(value: object): value is Horse {
    return true;
}

export function HorseFromJSON(json: any): Horse {
    return HorseFromJSONTyped(json, false);
}

export function HorseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Horse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'name': json['name'] == null ? undefined : json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'colorId': json['colorId'] == null ? undefined : json['colorId'],
        'breed': json['breed'] == null ? undefined : json['breed'],
        'breedId': json['breedId'] == null ? undefined : json['breedId'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'ageGroup': json['ageGroup'] == null ? undefined : AgeGroupFromJSON(json['ageGroup']),
        'mother': json['mother'] == null ? undefined : json['mother'],
        'motherRegId': json['motherRegId'] == null ? undefined : json['motherRegId'],
        'father': json['father'] == null ? undefined : json['father'],
        'fatherRegId': json['fatherRegId'] == null ? undefined : json['fatherRegId'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerRegId': json['ownerRegId'] == null ? undefined : json['ownerRegId'],
        'breeder': json['breeder'] == null ? undefined : json['breeder'],
        'breederRegId': json['breederRegId'] == null ? undefined : json['breederRegId'],
        'stockSize': json['stockSize'] == null ? undefined : json['stockSize'],
        'isBigHorse': json['isBigHorse'] == null ? undefined : json['isBigHorse'],
        'lNr': json['lNr'] == null ? undefined : json['lNr'],
        'size': json['size'] == null ? undefined : json['size'],
        'igvKennziffer': json['igvKennziffer'] == null ? undefined : json['igvKennziffer'],
        'accessCode': json['accessCode'] == null ? undefined : json['accessCode'],
    };
}

export function HorseToJSON(json: any): Horse {
    return HorseToJSONTyped(json, false);
}

export function HorseToJSONTyped(value?: Horse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'registerId': value['registerId'],
        'name': value['name'],
        'color': value['color'],
        'colorId': value['colorId'],
        'breed': value['breed'],
        'breedId': value['breedId'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday'] as any).toISOString().substring(0,10)),
        'ageGroup': AgeGroupToJSON(value['ageGroup']),
        'mother': value['mother'],
        'motherRegId': value['motherRegId'],
        'father': value['father'],
        'fatherRegId': value['fatherRegId'],
        'gender': value['gender'],
        'owner': value['owner'],
        'ownerId': value['ownerId'],
        'ownerRegId': value['ownerRegId'],
        'breeder': value['breeder'],
        'breederRegId': value['breederRegId'],
        'stockSize': value['stockSize'],
        'isBigHorse': value['isBigHorse'],
        'lNr': value['lNr'],
        'size': value['size'],
        'igvKennziffer': value['igvKennziffer'],
        'accessCode': value['accessCode'],
    };
}

